<template>
  <div class="simulation-title">
    <h1 class="simulation-title__heading">{{ title }}</h1>
  </div>
</template>

<script>
export default {
  name: 'TheTitle',
  props: {
    title: String,
  },
}
</script>

<style lang="scss">
  .simulation-title{
    background-color: $color-red;
    &__heading{
      font-weight: 800;
      color: #fff;
      text-align: center;
      @include pc{
        font-size: 28px;
      }
      @include sp{
        padding: 5px 0;
        font-size: 22px;
      }
    }
  }
</style>
